/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Metadata_LabelInputs */



/**
* | output |
* | --- |
* | "Metadata" |
*
* @param {Style_Guide_Manager_Metadata_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_metadata_label = /** @type {((inputs?: Style_Guide_Manager_Metadata_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Metadata_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Metadonnees")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadaten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метаданные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडाटा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Metadados")
	return /** @type {LocalizedString} */ ("Metadata")
});